import { __exports as a } from "../../../../_virtual/strings.es.js";
import { __require as _ } from "./common.es.js";
var g;
function p() {
  if (g) return a;
  g = 1;
  var l = _(), d = !0, h = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    d = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    h = !1;
  }
  for (var c = new l.Buf8(256), u = 0; u < 256; u++)
    c[u] = u >= 252 ? 6 : u >= 248 ? 5 : u >= 240 ? 4 : u >= 224 ? 3 : u >= 192 ? 2 : 1;
  c[254] = c[254] = 1, a.string2buf = function(n) {
    var f, r, t, e, i, o = n.length, x = 0;
    for (e = 0; e < o; e++)
      r = n.charCodeAt(e), (r & 64512) === 55296 && e + 1 < o && (t = n.charCodeAt(e + 1), (t & 64512) === 56320 && (r = 65536 + (r - 55296 << 10) + (t - 56320), e++)), x += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
    for (f = new l.Buf8(x), i = 0, e = 0; i < x; e++)
      r = n.charCodeAt(e), (r & 64512) === 55296 && e + 1 < o && (t = n.charCodeAt(e + 1), (t & 64512) === 56320 && (r = 65536 + (r - 55296 << 10) + (t - 56320), e++)), r < 128 ? f[i++] = r : r < 2048 ? (f[i++] = 192 | r >>> 6, f[i++] = 128 | r & 63) : r < 65536 ? (f[i++] = 224 | r >>> 12, f[i++] = 128 | r >>> 6 & 63, f[i++] = 128 | r & 63) : (f[i++] = 240 | r >>> 18, f[i++] = 128 | r >>> 12 & 63, f[i++] = 128 | r >>> 6 & 63, f[i++] = 128 | r & 63);
    return f;
  };
  function s(n, f) {
    if (f < 65534 && (n.subarray && h || !n.subarray && d))
      return String.fromCharCode.apply(null, l.shrinkBuf(n, f));
    for (var r = "", t = 0; t < f; t++)
      r += String.fromCharCode(n[t]);
    return r;
  }
  return a.buf2binstring = function(n) {
    return s(n, n.length);
  }, a.binstring2buf = function(n) {
    for (var f = new l.Buf8(n.length), r = 0, t = f.length; r < t; r++)
      f[r] = n.charCodeAt(r);
    return f;
  }, a.buf2string = function(n, f) {
    var r, t, e, i, o = f || n.length, x = new Array(o * 2);
    for (t = 0, r = 0; r < o; ) {
      if (e = n[r++], e < 128) {
        x[t++] = e;
        continue;
      }
      if (i = c[e], i > 4) {
        x[t++] = 65533, r += i - 1;
        continue;
      }
      for (e &= i === 2 ? 31 : i === 3 ? 15 : 7; i > 1 && r < o; )
        e = e << 6 | n[r++] & 63, i--;
      if (i > 1) {
        x[t++] = 65533;
        continue;
      }
      e < 65536 ? x[t++] = e : (e -= 65536, x[t++] = 55296 | e >> 10 & 1023, x[t++] = 56320 | e & 1023);
    }
    return s(x, t);
  }, a.utf8border = function(n, f) {
    var r;
    for (f = f || n.length, f > n.length && (f = n.length), r = f - 1; r >= 0 && (n[r] & 192) === 128; )
      r--;
    return r < 0 || r === 0 ? f : r + c[n[r]] > f ? r : f;
  }, a;
}
export {
  p as __require
};
//# sourceMappingURL=strings.es.js.map
